import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import SocketManager, { HANDLERS } from '../../lib/SocketManager';

export const ArenaContext = React.createContext({
	onlinePlayers: [],
	setOnlinePlayersCount: () => {
	},
});

const ArenaContextManager = (props) => {
	const {
		children,
	} = props;

	const [onlinePlayers, setOnlinePlayers] = useState([]);

	useEffect(() => {
		SocketManager.registerHandler(HANDLERS.ONLINE_PLAYERS, (players) => {
			setOnlinePlayers(players);
		});
	});

	return (
		<ArenaContext.Provider value={{ onlinePlayers }}>
			{children}
		</ArenaContext.Provider>
	);
};

ArenaContextManager.defaultProps = {
	children: null,
};

ArenaContextManager.propTypes = {
	children: PropTypes.shape({}),
};

export default ArenaContextManager;
